'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactCalendarPane = require('react-calendar-pane');

var _reactCalendarPane2 = _interopRequireDefault(_reactCalendarPane);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _ = require('..');

var _2 = require('.');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Calendar = function (_Component) {
  (0, _inherits3.default)(Calendar, _Component);

  function Calendar(props) {
    (0, _classCallCheck3.default)(this, Calendar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Calendar.__proto__ || (0, _getPrototypeOf2.default)(Calendar)).call(this));

    _moment2.default.locale(props.locale);
    return _this;
  }

  (0, _createClass3.default)(Calendar, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.calendar.setState({ date: (0, _moment2.default)(nextProps.date) });
    }
  }, {
    key: 'previous',
    value: function previous() {
      this.calendar.previous();
    }
  }, {
    key: 'next',
    value: function next() {
      this.calendar.next();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var ref = function ref(element) {
        return _this2.calendar = element;
      };
      return _react2.default.createElement(
        'div',
        { className: 'CalendarContainer' },
        _react2.default.createElement(
          'button',
          { className: 'previous', onClick: this.previous.bind(this), type: 'button' },
          _react2.default.createElement(_2.Icon, { name: 'chevronLeft' })
        ),
        _react2.default.createElement(
          'button',
          { className: 'next', onClick: this.next.bind(this), type: 'button' },
          _react2.default.createElement(_2.Icon, { name: 'chevronRight' })
        ),
        _react2.default.createElement(_reactCalendarPane2.default, {
          ref: ref,
          locale: this.props.locale,
          date: this.props.date,
          onSelect: this.props.onSelect,
          useNav: false
        })
      );
    }
  }]);
  return Calendar;
}(_react.Component);

Calendar.propTypes = {
  /**
   * Moment object representing the selected date.
   */
  date: _propTypes2.default.object,
  /**
   * Function that is called when a date is selected.
   */
  onSelect: _propTypes2.default.func.isRequired,
  /**
   * [Moment](https://momentjs.com/docs/#/i18n/) locale string
   */
  locale: _propTypes2.default.string
};
Calendar.defaultProps = {
  locale: _.CaligramReact.config().locale
};
exports.default = Calendar;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/Calendar.js
// module id = 262
// module chunks = 0